export default __webpack_public_path__ + "static/media/Info.45c9b13a.svg";